import React, { Component } from "react";
import { Link } from "react-router-dom";
import _ from "i18n";
import { SVG_ICONS } from "../../config/Common";

export default class SubMenuLinkUA extends Component {
  render() {
    const {
      title,
      icon,
      currentPage,
      isActive = false,
      handleSetCurrentPage,
    } = this.props;

    return (
      <li>
        <Link
          to={"/newsletter-ua/BASIC"}
          onClick={() => handleSetCurrentPage(currentPage, null)}
          className={`menu-ua__link ${isActive ? "active" : ""}`}
        >
          <img src={"/img/icons/" + SVG_ICONS[icon]} />
          <span className="title">{_(title)}</span>
        </Link>
      </li>
    );
  }
}
